module.exports = __webpack_public_path__ + "static/media/education 2.caed892b.svg";